module.exports = __webpack_public_path__ + "static/media/BY.c6f84ea6.webp";